import { TokenManager, ClientManager } from '../';

const successCodes = [200, 201, 202, 204, 206];

const Request = {

    getBaseUrl: () => {
        if (window.location.href.indexOf('localhost') !== -1) {
            return 'http://localhost:9090';
        } else if (window.location.href.indexOf('stage') !== -1) {
            return `https://account-api-stage.geckoengage.com`;
        } else {
            return `https://account-api.geckoengage.com`;
        }
    },

    prepareUrl: (endpoint = '', params = {}) => {
        const query = Request.prepareQueryString(params);

        if (endpoint.length && endpoint[0] === '/') {
            return `${Request.getBaseUrl()}${endpoint}${query}`;
        }
        return endpoint + query;
    },

    prepareQueryString: (params) => {
        var sane_params = Request.sanatizeParams(params);
        
        var str = [];
        for (var p in sane_params) {
            if (sane_params.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + '=' + encodeURIComponent(sane_params[p]));
            }
        }

        if (str.length === 0) {
            return '';
        }

        return '?' + str.join('&');
    },

    sanatizeParams: (params = {}) => {
        // Check params dont use undefined
        for (var prop in params) {
            if (params[prop] === undefined || params[prop] === null) {
                delete params[prop];
            }
        }
        return params;
    },

    post: async (endpoint, params = {}, options = {}) => {
        const headers = {}
        headers['Accept'] = 'application/json';
        headers['Content-Type'] = 'application/json';

        if (options.Authorization) {
            headers['Authorization'] = options.Authorization;
        }

        if (TokenManager.hasTokens()) {
            if (!options.dont_refresh_tokens) {
                await Request.refreshTokens();
            }
        }

        return new Promise((resolve, reject) => {
            fetch(Request.prepareUrl(endpoint), {
                method: 'POST',
                body: JSON.stringify(Request.sanatizeParams(params)),
                headers
            })
                .then(response => {
                    if (response.status === 401 && !options.ignore401) {
                        return Request.handle401();
                    }
                    
                    const resolveFunc = successCodes.includes(response.status) ? resolve : reject;

                    if (response.status === 204) {
                        resolveFunc(true);
                    } else if (!options.raw) {
                        response.json().then(resolveFunc)
                    } else {
                        resolveFunc(response);
                    }
                })
                .catch(reject)
        })
    },

    get: async (endpoint, params, options = {}) => {
        const headers = {};

        if (options.Authorization) {
            headers['Authorization'] = options.Authorization;
        }

        if (TokenManager.hasTokens()) {
            if (!options.dont_refresh_tokens) {
                await Request.refreshTokens();
            }
        }

        return new Promise((resolve, reject) => {
            fetch(Request.prepareUrl(endpoint, params), {
                method: 'GET',
                headers,
            })
                .then(response => {
                    if (response.status === 401 && !options.ignore401) {
                        return Request.handle401();
                    }

                    const resolveFunc = successCodes.includes(response.status) ? resolve : reject;

                    if (response.status === 204) {
                        resolveFunc(true);
                    } else if (!options.raw) {
                        response.json().then(resolveFunc)
                    } else {
                        resolveFunc(response);
                    }
                })
                .catch(reject);
        })
    },

    delete: async (endpoint, params = {}, options = {}) => {
        const headers = {}
        headers['Accept'] = 'application/json';
        headers['Content-Type'] = 'application/json';

        if (options.Authorization) {
            headers['Authorization'] = options.Authorization;
        }

        if (TokenManager.hasTokens()) {
            if (!options.dont_refresh_tokens) {
                await Request.refreshTokens();
            }
        }

        return new Promise((resolve, reject) => {
            fetch(Request.prepareUrl(endpoint, params), {
                method: 'DELETE',
                headers
            })
            .then(response => {
                if (response.status === 401 && !options.ignore401) {
                    return Request.handle401();
                }
                
                const resolveFunc = successCodes.includes(response.status) ? resolve : reject;

                if (response.status === 204) {
                    resolveFunc(true);
                } else if (!options.raw) {
                    response.json().then(resolveFunc)
                } else {
                    resolveFunc(response);
                }
            })
            .catch(reject);
        })
    },

    refreshTokens: function refreshTokens() {
        return TokenManager.refreshToken()
        .catch((err) => {
            Request.handle401();
        });
    },
    handle401: function() {
        window.location.href = '/logout' + ClientManager.toQueryString();
    }
};

export default Request;
